//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      contactPresets: {
        support: {
          name: "Shira",
          avatarSrc: "/support-headshot.jpg",
        },
        anima: {
          name: "Team Anima",
          avatarSrc: "/anima-logo.png",
        },
      },
    };
  },
  props: {
    contact: {
      type: String,
      default: "support",
    },
    messageHtml: {
      type: String,
      default: "nullush",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    contactName() {
      return this.contactPresets[this.contact].name;
    },
    contactAvatarSrc() {
      return this.contactPresets[this.contact]?.avatarSrc;
    },
    eventProps() {
      return { page: this.$route.name, screenWidth: window?.innerWidth };
    },
    contactHtml() {
      let html = `<b>${this.contactName}</b>`;
      if (this.contactName.toLowerCase().includes("anima")) {
        return html;
      }
      return `${html} from Anima`;
    },
  },
  methods: {
    toggleBubble(value) {
      if (!value) {
        return this.hideBubble();
      }
      if (this.$intercom.ready && value) {
        this.show = true;
        this.$tracking.trackEvent("website.intercom-bubble.show", {
          message: this.message,
          ...this.eventProps,
        });
      } else {
        this.$tracking.trackEvent(
          "website.intercom-bubble.show-attempt-failure",
          {
            message: this.message,
            intercomReady: this.$intercom.ready,
            ...this.eventProps,
          }
        );
      }
    },
    hideBubble() {
      this.$emit("hide");
      this.$tracking.trackEvent(
        "website.intercom-bubble.hide",
        this.eventProps
      );
    },
    onClick() {
      this.$tracking.trackEvent(
        "website.intercom-bubble.click",
        this.eventProps
      );
      if (this.$listeners.click) this.$emit("click");
      else this.openIntercom();
    },
    openIntercom() {
      this.hideBubble();
      this.$intercom("showNewMessage");
    },
  },
  watch: {
    show: "toggleBubble",
  },
};
